import { graphql, HttpResponse } from 'msw'
import {
  Occupation,
  type EnrollmentJointEmploymentData,
  type EnrollmentJointEmploymentSubmitOutput,
} from '../../../../models'

export const getEnrollmentJointEmploymentDataMock: EnrollmentJointEmploymentData = {
  isError: false,
  errors: [],
  activePerson: {
    applicationId: '1234567890',
    progress: 60,
    employmentStatus: 'EMPLOYED',
    occupation: Occupation.FINANCE,
    path: '/enrollment/joint/employment',
    name: {
      firstName: 'Jonathan',
      lastName: 'Doe',
    },
  },
}

export const submitEnrollmentJointEmploymentDataMock: EnrollmentJointEmploymentSubmitOutput = {
  isError: false,
  errors: [],
  activePerson: {
    path: '/enrollment/joint/finances',
  },
}

export const mockGetEnrollmentJointEmploymentData = graphql.mutation('getEnrollmentJointEmploymentData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: getEnrollmentJointEmploymentDataMock } })
})

export const mockSubmitEnrollmentJointEmploymentData = graphql.mutation('submitEnrollmentJointEmploymentData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: submitEnrollmentJointEmploymentDataMock } })
})

export const mockEnrollmentJointEmployment = [
  mockGetEnrollmentJointEmploymentData,
  mockSubmitEnrollmentJointEmploymentData,
]
